'use client';

export type APIErrorCode =
  | "UNAUTHORIZED"
  | "SERVICE_UNAVAILABLE"
  | "STORE_ALREADY_EXISTS"
  | "STORE_PENDING_DELETION"
  | "STORE_NOT_FOUND"
  | "STORE_ACCESS_DENIED"
  | "KEY_WRONG_STORE"
  | "VALIDATION_ERROR"
  | "INTERNAL_ERROR"
  | "INSUFFICIENT_BALANCE";

export interface APIError {
  code: APIErrorCode;
  message: string;
  details?: Record<string, string>;
}

const ERROR_MESSAGES: Record<APIErrorCode, string> = {
  UNAUTHORIZED: 'Требуется авторизация',
  SERVICE_UNAVAILABLE: 'Сервис временно недоступен, попробуйте через несколько минут',
  STORE_ALREADY_EXISTS: 'Этот магазин уже подключён к другому аккаунту. Если это ваш магазин — обратитесь в поддержку',
  STORE_PENDING_DELETION: 'Этот магазин сейчас в процессе удаления у другого пользователя. Попробуйте позже',
  STORE_NOT_FOUND: 'Магазин не найден',
  STORE_ACCESS_DENIED: 'Нет доступа к этому магазину',
  KEY_WRONG_STORE: 'Этот ключ принадлежит другому магазину, а не тому, который вы обновляете',
  VALIDATION_ERROR: 'Ошибка валидации данных',
  INTERNAL_ERROR: 'Произошла ошибка. Попробуйте ещё раз или обратитесь в поддержку',
  INSUFFICIENT_BALANCE: 'Недостаточно средств на балансе',
};

export function getErrorMessage(error: APIError): string {
  return ERROR_MESSAGES[error.code] || error.message || 'Произошла ошибка';
}

export function getErrorDetails(error: APIError): string | null {
  if (!error.details) return null;

  const details: string[] = [];
  if (error.details.reason) {
    details.push(error.details.reason);
  }

  return details.length > 0 ? details.join(', ') : null;
}

export function isServiceUnavailable(error: APIError): boolean {
  return error.code === 'SERVICE_UNAVAILABLE';
}

export function isUnauthorized(error: APIError): boolean {
  return error.code === 'UNAUTHORIZED';
}

export function formatApiError(error: APIError): string {
  const message = getErrorMessage(error);
  const details = getErrorDetails(error);
  return details ? `${message} (${details})` : message;
}
